const checkIfNotEqual = (value, match) => {
  return value !== match;
};

export default checkIfNotEqual;
